var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-nbhd-tips-panel"},[_c('shared-tips',{attrs:{"tips":_vm.tips,"is-vertical":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }